export default "__VITE_ASSET__j7t0sFKt__"